var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang"},_vm._l((_vm.languageList),function(lang,index){return _c('span',{key:lang.name,class:{'active': _vm.languageIndex == index},on:{"click":function($event){return _vm.changeLanguage(lang.name)}}},[_vm._v("\n      "+_vm._s(lang.val)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }